export default {

    PATIENT_LOGIN: {1: 'Login do Paciente', 2: 'Patient Login', 3: 'Inicio de Sesión del Paciente', 4: 'Connexion du Patient'},
    RETURN_TO_LOGIN: {1: 'Voltar', 2: 'Return', 3: 'Regresar', 4: 'Retour'},
    RESET_PASSWORD: {1: 'Resetar senha', 2: 'Reset Password', 3: 'Restablecer Contraseña', 4: 'Réinitialiser le mot de passe'},

    MONITORY: {1: 'Monitoria', 2: 'Monitoring', 3: 'Monitoreo', 4: 'Surveillance'},
    EXERCISES: {1: 'Exercícios', 2: 'Exercises', 3: 'Ejercicios', 4: 'Exercices'},
    PATIENT: {1: 'Paciente', 2: 'Patient', 3: 'Paciente', 4: 'Patient'},
    DENTIST: {1: 'Dentista', 2: 'Dentist', 3: 'Dentista', 4: 'Dentiste'},
    BALANCE_MANGOS: {1: 'Saldo de Mangos', 2: 'Mangos Balance', 3: 'Saldo de Mangos', 4: 'Solde de Mangos'},

    COMFIRMATION_LOGOUT: {1: "Deseja sair desta conta?", 2: "Do you want to log out of this account?", 3: "¿Desea salir de esta cuenta?", 4: "Voulez-vous vous déconnecter de ce compte?"},

    HOME_TITLE: {1: 'Home', 2: 'Home', 3: 'Inicio', 4: 'Accueil'},
    MENU: {1: 'Menu', 2: 'Menu', 3: 'Menú', 4: 'Menu'},

    MONITORY_TUTORIAL_TITLE_MENU: {1: 'Tutorial Monitoria', 2: 'Monitoring Tutorial', 3: 'Tutorial de Monitoreo', 4: 'Tutoriel de Surveillance'},
    EXERCISES_TUTORIAL_TITLE_MENU: {1: 'Tutorial Exercícios', 2: 'Exercises Tutorial', 3: 'Tutorial de Ejercicios', 4: 'Tutoriel d\'Exercices'},
    MONITORY_TUTORIAL_TITLE: {1: 'Tutorial de Monitoria', 2: 'Monitoring Tutorial', 3: 'Tutorial de Monitoreo', 4: 'Tutoriel de Surveillance'},
    EXERCISES_TUTORIAL_TITLE: {1: 'Tutorial de Exercícios', 2: 'Exercises Tutorial', 3: 'Tutorial de Ejercicios', 4: 'Tutoriel d\'Exercices'},

    START: {1: 'Iniciar {0}', 2: 'Start {0}', 3: 'Iniciar {0}', 4: 'Commencer {0}'},
    START_MONITORY_EXERCISE: {1: 'Iniciar', 2: 'Start', 3: 'Iniciar', 4: 'Commencer'},
    FINISH: {1: 'Finalizar', 2: 'Finish', 3: 'Finalizar', 4: 'Terminer'},
    LOGOUT: {1: "Sair", 2: "Logout", 3: "Salir", 4: "Déconnexion"},

    INFO_PATIENT_TITLE: {1: 'Informações do Paciente', 2: 'Patient Information', 3: 'Información del Paciente', 4: 'Informations du Patient'},
    TUTORIALS_TITLE: {1: 'Tutoriais', 2: 'Tutorials', 3: 'Tutoriales', 4: 'Tutoriels'},

    STARS: {1: 'Estrelas', 2: 'Stars', 3: 'Estrellas', 4: 'Étoiles'},
    START_CAPTURE: {1: 'Iniciar captura', 2: 'Start Capture', 3: 'Iniciar Captura', 4: 'Commencer la Capture'},

    ERROR_PATIENT_NOT_DETECTED: {1: 'Paciente não detectado', 2: 'Patient not detected', 3: 'Paciente no detectado', 4: 'Patient non détecté'},
    TOTAL_MINUTES_PASSED: {1: 'Minutos passados: {0}', 2: 'Minutes passed: {0}', 3: 'Minutos pasados: {0}', 4: 'Minutes écoulées: {0}'},
    QUANTITY_OPEN_LIP: {1: 'Lábio aberto: {0}', 2: 'Open lip: {0}', 3: 'Labio abierto: {0}', 4: 'Lèvre ouverte: {0}'},

    ATTENTION_PERMISSION_VIDEO_DENIED: {1: 'A permissão de câmera foi recusada, favor conceder acesso a câmera nas configurações', 2: 'Camera permission was denied, please grant camera access in settings', 3: 'Se denegó el permiso de la cámara, por favor conceda acceso a la cámara en la configuración', 4: 'L\'autorisation de la caméra a été refusée, veuillez accorder l\'accès à la caméra dans les paramètres'},
    YES: {1: 'Sim', 2: 'Yes', 3: 'Sí', 4: 'Oui'},
    NO: {1: 'Não', 2: 'No', 3: 'No', 4: 'Non'},
}
